import React from 'react';
import bottom_bg from '../images/bottom-bg.jpg'
import Qualification from './Qualification'
import Property from './Property'
import './Bottom.css'

export default function Bottom(){
   return(
        <div className='bottom'>
           <img className='bottom-bg' src={bottom_bg} alt='bottom-bg'/>
           <Qualification/>
           <Property/>
        </div>
   )
}